import React from "react";
import { Heading } from "../../../design/heading";
import { Card } from "../../../design/card";
import { Button } from "../../../design/button";
import { Text } from "../../../design/text";
import { useCustodyOrder } from "../../../contexts/CustodyOrderContext";
import moment from "moment";
import { useCreateCustodyOrderDialog } from "../../../providers/CreateCustodyOrderDialogProvider/CreateCustodyOrderDialogProvider";
import CustodyOrderTypeBadge from "../../../components/CustodyOrderTypeBadge";

interface Props {}

const CurrentCustodyOrder: React.FC<Props> = ({}) => {
  const { currentCustodyOrder } = useCustodyOrder();
  const { openDialog } = useCreateCustodyOrderDialog();

  if (!currentCustodyOrder) {
    return (
      <Card>
        <Heading level={5}>Custody Order</Heading>
        <Text>No custody order available.</Text>
      </Card>
    );
  }

  return (
    <Card>
      <Heading level={5}>Custody Order</Heading>
      <Text>{currentCustodyOrder?.title}</Text>
      {currentCustodyOrder?.updatedAt && (
        <Text>
          Ordered: {moment.utc(currentCustodyOrder.updatedAt).format("LL")}
        </Text>
      )}
      <Button
        className="mt-2"
        href={`/custody-order/${currentCustodyOrder?._id}`}
      >
        View Order
      </Button>
    </Card>
  );
};

export default CurrentCustodyOrder;
